import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Form } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import Model from "../Model";
import * as Yup from "yup";
import DropzoneImageUpload from "../Properties/DropzoneImageUpload";
import { toast } from "react-toastify";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const UploadDocument = ({
  uploadDocumentMutate,
  uploadDocumentLoading,
  setUploadDocument,
  selectedData,
}) => {
  const [selectedDocument, setSelectedDocument] = useState("Aadhaar Card");

  const name = (name) => {
    if (!name) return "";
    const lowerCaseName = name.trim().toLowerCase();
    return lowerCaseName.length > 10
      ? `${lowerCaseName.slice(0, 10)}...`
      : lowerCaseName;
  };

  const InitialValues = {
    name: selectedData?.name,
    mobile: selectedData?.mobile,
    status: selectedData?.status,
    id: selectedData?.id,
  };
  const validationSchema = Yup.object({
    tenantDocumentImage: Yup.mixed().required("Document is required"),
  });

  const SubmitHandler = (values) => {
    if (!values.tenantDocumentImage && !selectedData?.documentPath) {
      toast.error("Please upload the Owner Document.");
      return;
    }
    uploadDocumentMutate(values);
  };

  const renderUploadFields = (selectedDocument, values) => {
    if (selectedDocument === "Aadhaar Card") {
      return (
        <>
          <InputGroup>
            <Label htmlFor="document">
              Front Side<span className="text-red-500">*</span>
            </Label>
            <div>
              <DropzoneImageUpload
                setUploadFile={(file) => (values.tenantDocumentImage = file)}
                componentFor="document"
              />
            </div>
          </InputGroup>
          <InputGroup>
            <Label htmlFor="document">Back Side</Label>
            <div>
              <DropzoneImageUpload
                setUploadFile={(file) =>
                  (values.tenantDocumentBackImage = file)
                }
                componentFor="document"
              />
            </div>
          </InputGroup>
        </>
      );
    } else if (selectedDocument) {
      return (
        <InputGroup>
          <Label htmlFor="document">
            Front Side<span className="text-red-500">*</span>
          </Label>
          <div>
            <DropzoneImageUpload
              setUploadFile={(file) => (values.ownerDocumentImage = file)}
              componentFor="document"
            />
          </div>
        </InputGroup>
      );
    }
    return null; // Return nothing if no document is selected
  };

  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setUploadDocument}>
      <Title>Upload Document</Title>

      {uploadDocumentLoading && <Loading />}

      {!uploadDocumentLoading && (
        <Formik
          initialValues={InitialValues}
          validationSchema={validationSchema}
          onSubmit={SubmitHandler}
          enableReinitialize
        >
          {({ values }) => (
            <Form>
              <Wrapper>
                <InputGroup>
                  <Label htmlFor="documentType">Select Document<span className="text-red-500">*</span></Label>
                  <Select
                    id="documentType"
                    style={{ height: "40px" }}
                    className="w-full pl-2"
                    value={selectedDocument}
                    onChange={(e) => {
                      setSelectedDocument(e.target.value);
                    }}
                  >
                    <MenuItem value="Aadhaar Card">Aadhaar Card</MenuItem>
                    <MenuItem value="Pan Card">Pan Card</MenuItem>
                    <MenuItem value="Student/Employee Id">
                      Student/Employee ID
                    </MenuItem>
                    <MenuItem value="Police Verification">
                      Police Verification
                    </MenuItem>
                  </Select>
                </InputGroup>
                {/* {selectedDocument === "Aadhaar Card" && (
                  <>
                    <InputGroup>
                      <Label htmlFor="document">Front Side</Label>
                      <div>
                        <DropzoneImageUpload
                          setUploadFile={(file) =>
                            (values.tenantDocumentImage = file)
                          }
                          componentFor="document"
                        />
                      </div>
                    </InputGroup>
                    <InputGroup>
                      <Label htmlFor="document">Back Side</Label>
                      <div>
                        <DropzoneImageUpload
                          setUploadFile={(file) =>
                            (values.tenantDocumentImage = file)
                          }
                          componentFor="document"
                        />
                      </div>
                    </InputGroup>
                  </>
                )}
                {selectedDocument !== "Aadhar Card" && (
                  <InputGroup>
                    <Label htmlFor="document">Front Side</Label>
                    <div>
                      <DropzoneImageUpload
                        setUploadFile={(file) =>
                          (values.ownerDocumentImage = file)
                        }
                        componentFor="document"
                      />
                    </div>
                  </InputGroup>
                )} */}
                {renderUploadFields(selectedDocument, values)}

                {selectedData?.documentPath && (
                  <InputGroup>
                    <div className="flex items-center mt-[-15px]">
                      <svg
                        className="h-4 w-4 text-primary-color"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                        />
                      </svg>
                      <a
                        href={selectedData.documentPath}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline text-primary-color ml-1 text-sm"
                      >
                        {name(selectedData?.name)}/document.png
                      </a>
                    </div>
                  </InputGroup>
                )}
              </Wrapper>
              <BtnWrapper>
                <SubmitBtn type="submit">Upload</SubmitBtn>
              </BtnWrapper>
            </Form>
          )}
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`grid gap-6 my-6 px-1 `;
const Title = tw.h2` text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const BtnWrapper = tw.div` w-full flex items-center justify-center space-x-10 mt-8`;

export default UploadDocument;
